function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.0262 9.6498H24.9988V9.6H13.5194V14.4H20.7278C19.6762 17.1942 16.8504 19.2 13.5194 19.2C9.29315 19.2 5.86657 15.9762 5.86657 12C5.86657 8.0238 9.29315 4.8 13.5194 4.8C15.4703 4.8 17.2451 5.4924 18.5965 6.6234L22.2042 3.2292C19.9262 1.2318 16.8791 0 13.5194 0C6.47561 0 0.764648 5.373 0.764648 12C0.764648 18.627 6.47561 24 13.5194 24C20.5633 24 26.2743 18.627 26.2743 12C26.2743 11.1954 26.1862 10.41 26.0262 9.6498Z",
  fill: "#FBC02D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.23547 6.4146L6.42606 9.306C7.55996 6.6648 10.3061 4.8 13.5196 4.8C15.4705 4.8 17.2453 5.4924 18.5967 6.6234L22.2044 3.2292C19.9264 1.2318 16.8793 0 13.5196 0C8.62053 0 4.3719 2.6022 2.23547 6.4146Z",
  fill: "#E53935"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5198 24C16.8143 24 19.8079 22.8138 22.0712 20.8848L18.1236 17.742C16.843 18.6546 15.2512 19.2 13.5198 19.2C10.2022 19.2 7.38533 17.2098 6.32413 14.4324L2.16479 17.4474C4.27571 21.3336 8.5626 24 13.5198 24Z",
  fill: "#4CAF50"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.0263 9.64978L26.016 9.59998H24.9989H13.5195V14.4H20.7279C20.2228 15.7422 19.3051 16.8996 18.1215 17.7426C18.1221 17.742 18.1227 17.742 18.1234 17.7414L22.071 20.8842C21.7917 21.123 26.2743 18 26.2743 12C26.2743 11.1954 26.1863 10.41 26.0263 9.64978Z",
  fill: "#1565C0"
});

function SvgGoogleSignIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSignIn);
export default __webpack_public_path__ + "static/media/Google-SignIn.b2cfb7b9.svg";
export { ForwardRef as ReactComponent };